import iconDepoimento01 from '~/assets/user-img-depoimento-01.jpg';
import iconDepoimento02 from '~/assets/user-img-depoimento-02.jpg';
import iconDepoimento03 from '~/assets/user-img-depoimento-03.jpg';
import iconDepoimento04 from '~/assets/user-img-depoimento-04.jpg';
import iconDepoimento05 from '~/assets/user-img-depoimento-05.jpg';
import iconDepoimento06 from '~/assets/user-img-depoimento-06.jpg';
import iconDepoimentoVideo01 from '~/assets/user-img-depoimento-video-01.jpg';
import iconDepoimentoVideo02 from '~/assets/user-img-depoimento-video-02.jpg';
import iconDepoimentoVideo03 from '~/assets/user-img-depoimento-video-03.jpg';
import iconDepoimentoVideo04 from '~/assets/user-img-depoimento-video-04.jpg';
import iconDepoimentoVideo05 from '~/assets/user-img-depoimento-video-05.jpg';
import iconDepoimentoVideo06 from '~/assets/user-img-depoimento-video-06.jpg';

export function loadDepoimentos() {
  return [
    {
      id: 1,
      id_video: 'HmPl7ZiB7fE',
      img_video: iconDepoimentoVideo01,
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin quis libero et quam dictum tincidunt eu vel tellus. Praesent mollis mollis neque in consectetur. Integer facilisis purus sed orci volutpat, quis pretium sem consectetur.',
      user: iconDepoimento01,
      user_title: 'Nicole Fasanella',
      user_setor: 'Profa. da PUC-SP',
      user_time: 'Today 08:45 PM',
    },
    {
      id: 2,
      id_video: 'DpkLQ4O9r_s',
      img_video: iconDepoimentoVideo02,
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin quis libero et quam dictum tincidunt eu vel tellus. Praesent mollis mollis neque in consectetur. ',
      user: iconDepoimento02,
      user_title: 'Marcelo Treff',
      user_setor: 'Prof. da PUC-SP',
      user_time: 'Today 08:45 PM',
    },
    {
      id: 3,
      id_video: 'CcATapBTv3Q',
      img_video: iconDepoimentoVideo03,
      text:
        'Integer facilisis purus sed orci volutpat, quis pretium sem consectetur. Aenean a nulla est. Proin pulvinar tempor metus, in rutrum neque lacinia sed.',
      user: iconDepoimento03,
      user_title: 'Julio Wainer',
      user_setor: 'Prof. da PUC-SP',
      user_time: 'Today 08:45 PM',
    },
    {
      id: 4,
      id_video: 'jqVNV7bt46s',
      img_video: iconDepoimentoVideo04,
      text:
        'Integer facilisis purus sed orci volutpat, quis pretium sem consectetur. Aenean a nulla est. Proin pulvinar tempor metus, in rutrum neque lacinia sed.',
      user: iconDepoimento04,
      user_title: 'Vera Lucia Vieira',
      user_setor: 'Profa. da PUC-SP',
      user_time: 'Today 08:45 PM',
    },
    {
      id: 5,
      id_video: 'o-AKpXOC9Uw',
      img_video: iconDepoimentoVideo05,
      text:
        'Integer facilisis purus sed orci volutpat, quis pretium sem consectetur. Aenean a nulla est. Proin pulvinar tempor metus, in rutrum neque lacinia sed.',
      user: iconDepoimento05,
      user_title: 'Claudemir Galvani',
      user_setor: 'Prof. da PUC',
      user_time: 'Today 08:45 PM',
    },
    {
      id: 6,
      id_video: 'nsYz0Wr6Yz8',
      img_video: iconDepoimentoVideo06,
      text:
        'Integer facilisis purus sed orci volutpat, quis pretium sem consectetur. Aenean a nulla est. Proin pulvinar tempor metus, in rutrum neque lacinia sed.',
      user: iconDepoimento06,
      user_title: 'Pedro Aguerre',
      user_setor: 'Prof. da PUC',
      user_time: 'Today 08:45 PM',
    },
  ];
}
